@if (etiquette) {
  <div class="pr-sum-etiquette">
    <div>{{ etiquette }}</div>
  </div>
}
<div class="pr-sum-header" [ngClass]="clazz">{{ label }}</div>
<div class="pr-sum-body">
  <ng-content select="[beforeItems]"></ng-content>
  <div class="pr-sum-items">
    <ng-content></ng-content>
  </div>
  <ng-content select="[afterItems]"></ng-content>
</div>
